var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.injections.components.VueContentLoading,{tag:"component",attrs:{"primary":_vm.parent.$scss.colors.cardBg,"secondary":_vm.parent.$scss.colors.inputBg,"height":196}},[_c('rect',{attrs:{"x":"0","y":"0","rx":"4","ry":"4","width":"400","height":"196"}})])}
var staticRenderFns = []

export { render, staticRenderFns }